import * as fs from "fs";
import * as ko from "knockout";
import * as moment from "moment"
import { RNSAPI } from "../../api";
import { Utils } from "../../utils";
import { MainViewModel } from "../../main";
import '../dialog/dialog';
import { DialogViewModel } from '../dialog/dialog';

class ResubmissionViewModel {
    modalTitle = ko.observable("");
    modalKeys = ko.observableArray([]);
    modalColumns = ko.observableArray([]);
    modalData = ko.observableArray([]);
    modalHandleSelection: KnockoutObservable<(selectedObject: any) => void> = ko.observable();

    async pickGeneric(title, keys, columns, data) {
        this.modalTitle(title);
        this.modalKeys(keys);
        this.modalColumns(columns);
        this.modalData(data);
    };

    async pickCase() {
        let cases = (await RNSAPI.getCases()).Payload.Cases;
        this.pickGeneric("Akte", ["Registernummer", "Rubrum", "Wegen"], ["Registernummer", "Rubrum", "Wegen"], cases);
        this.modalHandleSelection((selectedObject) => this.basicResubmission().Case_ID(selectedObject()["Registernummer"]));
        $('#modal').modal('show');
    };

    async pickDeadlineNumber() {
        let reasons = (await RNSAPI.getResubmissionReasons()).Payload.Reasons;
        this.pickGeneric("Grund", ["DeadLineName"], ["Beschreibung"], reasons);
        this.modalHandleSelection((selectedObject) => {
            this.basicResubmission().DeadLineNr(selectedObject().DeadLineNr);
            this.deadlineReason(selectedObject());
        });
        $('#modal').modal('show');
    };

    IsEditMode = ko.observable(false)

    deadlineDate = ko.observable(moment().format("DD.MM.YYYY"));
    creationDate = ko.observable(moment().format("DD.MM.YYYY"));

    parseDate = (dateStr: string) => moment.utc(dateStr, "DD.MM.YYYY", true);

    newBasicResubmission() {
        let obj = {
            AdressTyp: ko.observable(""),
            AngelegtVon: ko.observable(""),
            AnlageDatum: ko.computed(() => this.parseDate(this.creationDate()).toISOString()),
            Case_ID: ko.observable(""),
            Comment: ko.observable(""),
            Copies: ko.observable(""),
            DeadLineDate: ko.computed(() => this.parseDate(this.deadlineDate()).toISOString()),
            DeadLineNr: ko.observable(""),
            DeadLineReason: ko.observable(""),
            EDAVerfahren: ko.observable(false),
            ErledigtDatum: ko.observable(null),
            ErledigtVon: ko.observable(""),
            ForderungskontoDrucken: ko.observable(false),
            Formulardruck: ko.observable(false),
            HonorarForderung: ko.observable(false),
            Keyword: ko.observable(""),
            PapierArtID: ko.observable(""),
            Quotelung: ko.observable(0),
            Referat: ko.observable(""),
            Sachbearbeiter: ko.observable(RNSAPI.User() ? RNSAPI.User().username : "GR"),
            Standardtext: ko.observable(""),
            Status: ko.observable("N")
        };

        return ko.observable(obj);
    };

    basicResubmission = this.newBasicResubmission();

    deadlineReason = ko.observable(null);
    IsDeadlineNecessary = ko.computed(() => {
        let reason = this.deadlineReason();
        let nr = this.basicResubmission().DeadLineNr();

        if (!nr) return true;
        else if (reason && reason.DeadLineElapseTime) return false;
        else return true;
    });


    resetObject(obj) {
        for (let key in obj) {
            obj[key](null);
        }
    }


    checkDate = (str: string) => this.parseDate(str).isValid();

    async postData() {
        $(".form-group").each(function () { $(this).removeClass("has-error"); });
        if (!Utils.checkErrors(["DeadLineReason", "Case_ID"], this.basicResubmission(), "resubmission", [Utils.checkString])) return;

        let dateChecks = this.IsDeadlineNecessary() ? ["deadlineDate", "creationDate"] : ["creationDate"];
        if (!Utils.checkErrors(dateChecks, this, "", [Utils.checkString, this.checkDate])) return;

        console.log(ko.toJS(this.basicResubmission()));

        if (this.IsEditMode()) {
            try {
                let result = await RNSAPI.updateResubmission(this.basicResubmission());
                if (result.Type === "EditSuccess") {
                    MainViewModel.RoutingTable.showResubmissionOverview();
                } else {
                    alert("Fehler beim Speichern.");
                }
            } catch (e) {
                console.log(e);
                alert("Fehler beim Speichern: " + e.responseText);
            }
        } else {
            try {
                let result = await RNSAPI.createResubmission(this.basicResubmission());
                if (result.Type === "CreateSuccess") {
                    MainViewModel.RoutingTable.showResubmissionOverview();
                } else {
                    alert("Fehler beim Anlegen der Wiedervorlage.");
                }
            } catch (e) {
                console.log(e);
                alert("Fehler beim Anlegen: " + e.responseText);
            }
        }
    };

    async loadResubmission(id: string) {
        try {
            let result = await RNSAPI.getResubmission(id);

            if (result.Type === "ResubmissionFound") {
                let resubmission = result.Payload.Resubmission;
                let newResubmission = this.newBasicResubmission();
                let obj = newResubmission();

                let excluding = ["DeadLineDate", "AnlageDatum"];

                for (let key in resubmission) {
                    if (obj[key] === undefined) {
                        obj[key] = resubmission[key];
                    } else if (excluding.indexOf(key) === -1) {
                        obj[key](resubmission[key]);
                    }
                }

                this.basicResubmission(obj);
                let momentDeadLine = moment.utc(resubmission.DeadLineDate).local();
                let momentCreation = moment.utc(resubmission.AnlageDatum).local();
                this.deadlineDate(momentDeadLine.format("DD.MM.YYYY"));
                this.creationDate(momentCreation.format("DD.MM.YYYY"));
            } else {
                alert("Wiedervorlage nicht gefunden.");
            }
        } catch (e) {
            alert("Verbindung zum Server abgebrochen.");
        }
    }

    constructor(params: any) {
        params = params || {};
        let id = params.id;
        this.IsEditMode(id !== undefined);

        if (this.IsEditMode()) {
            this.loadResubmission(id);
        } else {
            if (params.caseId) this.basicResubmission().Case_ID(params.caseId);
        }
    }
}

let html = fs.readFileSync(__dirname + '/resubmission.html', 'utf8');

ko.components.register("resubmission-view", {
    viewModel: ResubmissionViewModel,
    template: html
});
